module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-multiline is-mobile"
  }, [_c('div', {
    staticClass: "column is-full-mobile is-6-desktop "
  }, [_c('vue-adsense', {
    attrs: {
      "ad-style": "display:block",
      "ad-client": "ca-pub-8717113253404092",
      "ad-slot": "7401582331",
      "ad-format": "auto"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('base-card', {
    attrs: {
      "title": _vm.capstitle,
      "content": _vm.getDescription(_vm.file)
    }
  }, [(_vm.file.userid) ? _c('card-footer-item', {
    staticClass: "short-link",
    attrs: {
      "href": 'https://flb.st/' + _vm.$route.params.fileid,
      "data-label": "Copied"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.copyUrl($event)
      }
    },
    slot: "footer"
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-share-alt",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("  \n        Short Link\n      ")]) : _vm._e(), _vm._v(" "), (_vm.file.userid) ? _c('card-footer-item', {
    attrs: {
      "href": '/download/' + _vm.file.userid + '/' + _vm.file.name
    },
    slot: "footer"
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("  \n        Download\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('vue-adsense', {
    attrs: {
      "ad-style": "display:block",
      "ad-client": "ca-pub-8717113253404092",
      "ad-slot": "7401582331",
      "ad-format": "auto"
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-full-mobile is-4-desktop is-offset-sidebar-desktop"
  }, [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Popular Uploads")]), _vm._v(" "), _c('collapse', {
    attrs: {
      "accordion": ""
    }
  }, _vm._l((_vm.popularfiles), function(file) {
    return _c('collapse-item', {
      key: file.randname,
      attrs: {
        "title": _vm._f("capitalize")(file.name)
      }
    }, [_c('div', {
      staticClass: "is-inline-block"
    }, [_c('strong', [_vm._v("Size")]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "filedata"
    }, [_vm._v(_vm._s(_vm._f("prettyBytes")(file.size)))])]), _vm._v(" "), _c('div', {
      staticClass: "is-inline-block"
    }, [_c('strong', [_vm._v("Downloads")]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "filedata"
    }, [_vm._v(_vm._s(_vm._f("formatNumber")(file.downloads)))])]), _vm._v(" "), _c('div', {
      staticClass: "is-inline-block"
    }, [_c('a', {
      attrs: {
        "href": '/file/' + file.randname
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-cloud-download",
      style: ('margin-left:18%;')
    })])])])
  }))], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "adcode2"
  }, [_c('span', [_c('vue-adsense', {
    attrs: {
      "ad-style": "display:block",
      "ad-client": "ca-pub-8717113253404092",
      "ad-slot": "6696673629",
      "ad-format": "auto"
    }
  })], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Recent Uploads")]), _vm._v(" "), _c('collapse', {
    attrs: {
      "accordion": ""
    }
  }, _vm._l((_vm.recentfiles), function(file) {
    return _c('collapse-item', {
      key: file.randname,
      attrs: {
        "title": _vm._f("capitalize")(file.name)
      }
    }, [_c('div', {
      staticClass: "is-inline-block"
    }, [_c('strong', [_vm._v("Size")]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "filedata"
    }, [_vm._v(_vm._s(_vm._f("prettyBytes")(file.size)))])]), _vm._v(" "), _c('div', {
      staticClass: "is-inline-block"
    }, [_c('strong', [_vm._v("Downloads")]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "filedata"
    }, [_vm._v(_vm._s(_vm._f("formatNumber")(file.downloads)))])]), _vm._v(" "), _c('div', {
      staticClass: "is-inline-block"
    }, [_c('a', {
      attrs: {
        "href": '/file/' + file.randname
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-cloud-download",
      style: ('margin-left:18%;')
    })])])])
  }))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7a3beca5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/FileInfo.vue
// module id = 163
// module chunks = 34